import {
  Box,
  LinearProgress,
  linearProgressClasses,
  styled,
  Typography,
} from "@mui/material";
import React, { useCallback, useState } from "react";
import SalonTymLady from "../genericComponents/animation/SalonTymLady";
import { AppointmentDetails, ResponseObject } from "@/app/classes/main";
import { ApiService } from "@/app/services/AppService";
import { getToken } from "@/app/services/HolderService";
import { useRouter } from "next/navigation";
import { MainLoader } from "../genericComponents/MainLoader/MainLoader";

export const BookingProgressBar: React.FC = ({}) => {
  const [dialogAppointmentData, setDialogAppointmentData] =
    React.useState<AppointmentDetails>();
  const [loading, setLoading] = useState(false);
  const router = useRouter();
  const apiService = React.useMemo(() => new ApiService(), []);

  const orderDate = dialogAppointmentData?.bookingDate ?? "";
  const [day, month, year] = orderDate?.split("-").map(Number);
  const date = new Date(year, month - 1, day);

  const options: Intl.DateTimeFormatOptions = {
    weekday: "short",
    day: "numeric",
    month: "short",
  };

  const formattedDate = date.toLocaleDateString("en-US", options);
  const formattedTime = dialogAppointmentData?.bookingSlot?.split(" - ")[0];

  const getOrderDetails = React.useCallback(
    async (id: any) => {
      if (id) {
        try {
          const response = await apiService.get<ResponseObject>(
            apiService.findMyOrders + id,
            getToken()!
          );
          if (response?.status === "success") {
            setDialogAppointmentData(response?.object);
          } else {
            console.log("Error:", response);
          }
        } catch (error) {
          console.log("Error:", error);
        }
      } else {
        console.log("OrderId not found");
      }
    },
    [apiService]
  );

  const getOrderId = useCallback(async () => {
    const responseObject: ResponseObject | undefined =
      await apiService.get<ResponseObject>(apiService.myOrders, getToken()!);
    if (responseObject?.status == "success") {
      const orderId = responseObject?.object?.ongoingOrders[0]?.id;
      getOrderDetails(orderId);
    }
  }, [apiService, getOrderDetails]);

  React.useEffect(() => {
    getOrderId();
  }, [getOrderId]);

  const handleNavigate = () => {
    router.push("/appointments");
  };

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 4,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? "#15741a" : "#15741a",
    },
  }));

  const completedPercentage = dialogAppointmentData?.orderJourneyTracking
    ? (dialogAppointmentData.orderJourneyTracking.filter(
        (i: any) => i.completed
      ).length /
        dialogAppointmentData.orderJourneyTracking.length) *
      100
    : 0;

  return (
    <>
      {loading && <MainLoader />}
      {dialogAppointmentData &&
        Object.keys(dialogAppointmentData)?.length > 0 && (
          <Box
            sx={{
              p: 1,
              display: "flex",
              justifyContent: "left",
              alignItems: "center",
            }}
            onClick={() => {
              setLoading(true);
              handleNavigate();
            }}
          >
            <SalonTymLady
              code={dialogAppointmentData?.orderStatus?.code ?? 1}
            />
            <Box sx={{ width: "100%" }}>
              <Box sx={{ width: "100%", display: "grid" }}>
                <Typography
                  variant="body2"
                  sx={{
                    textWrap: "nowrap",
                    overflow: "hidden",
                    fontSize: "14px",
                  }}
                >
                  {dialogAppointmentData?.orderServices
                    ?.map((item: any) => item?.services?.name)
                    .filter((item: any) => item !== undefined)
                    .join(", ")}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    textWrap: "nowrap",
                    overflow: "hidden",
                    fontSize: "12px",
                  }}
                >
                  {formattedDate} &nbsp; &nbsp;
                  {formattedTime}
                </Typography>
              </Box>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  margin: "2px 0px",
                }}
              >
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: "10px",
                  }}
                >
                  Confirmed
                </Typography>
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: "10px",
                  }}
                >
                  Assigned
                </Typography>
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: "10px",
                  }}
                >
                  On the way
                </Typography>
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: "10px",
                  }}
                >
                  Started
                </Typography>
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: "10px",
                  }}
                >
                  Completed
                </Typography>
              </Box>
              <BorderLinearProgress
                variant="determinate"
                aria-label="proress bar"
                value={completedPercentage}
              />
            </Box>
          </Box>
        )}
    </>
  );
};
